import { render, staticRenderFns } from "./NoSidebarLayout.vue?vue&type=template&id=6e578f14"
import script from "./NoSidebarLayout.vue?vue&type=script&lang=ts"
export * from "./NoSidebarLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e578f14')) {
      api.createRecord('6e578f14', component.options)
    } else {
      api.reload('6e578f14', component.options)
    }
    module.hot.accept("./NoSidebarLayout.vue?vue&type=template&id=6e578f14", function () {
      api.rerender('6e578f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/NoSidebarLayout.vue"
export default component.exports